import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsMenuModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { PickerModule } from '@ctrl/ngx-emoji-mart';

import { ChatService } from '../../../coaching-base/chat.service';
import { CmpsCoachingTagsModule } from '../../../coaching-tags/coaching-tags.module';
import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { epicObs } from '../../../store';
import { CmpsTeamsCallAuthModule } from '../../../teams-call/auth';

import { CmpsCoachingClickOutsideModule } from './directive/click-outside.module';
import { TeamschatDialogComponent } from './teamschat-dialog.component';
import { teamschatDialogEpics } from './teamschat-dialog.epic';
import { TranslationIdMap } from './teamschat-dialog.i18n';

@NgModule({
    declarations: [TeamschatDialogComponent],
    exports: [TeamschatDialogComponent],
    imports: [
        CmpsButtonModule,
        CmpsCheckboxModule,
        CmpsCoachingClickOutsideModule,
        CmpsCoachingTagsModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsMenuModule,
        CmpsTeamsCallAuthModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
        PickerModule,
        ReactiveFormsModule,
    ],
    providers: [ChatService],
})
export class CmpsCoachingTeamschatDialogModule {
    constructor() {
        teamschatDialogEpics.forEach((e) => epicObs.next(e));
    }
}
